import axios from "axios";
import { API } from "@/lib/api";

const client = axios.create({ baseURL: API, timeout: 15000 });

/** Fetch latest opt-in wall entries. */
export const fetchWall = async (limit = 20) => {
  const { data } = await client.get(`/wall`, { params: { limit } });
  return data;
};

/** POST an opt-in entry — backend verifies the tx on BSC RPC. */
export const submitWallEntry = async (nick, txHash) => {
  const { data } = await client.post(`/wall/entry`, { nick, tx_hash: txHash });
  return data;
};
